<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <div class="d-flex align-items-center">
                                <div class="edit">
                                    <button (click)="backToMyProject()">
                                        <span><i class="ri-arrow-left-line"></i></span>
                                    </button>
                                </div>
                                <h3 class="px-3">My Project</h3>
                            </div>
                        </div>
                        <div class="col-sm-6 d-flex justify-content-end" *ngIf="this.isPMOLeadORManager || this.isAdministrator">
                            <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                                <button type="button" title="Edit" (click)="editOpenModal()" data-bs-toggle="modal" data-bs-target="#createTask" >
                                    <span><i class="ri-pencil-line"></i></span>
                                </button>
                            </div>
                            <div class="delete" *ngIf="selectedCheckboxData.length > 0">
                                <button type="button" title="Delete" data-bs-toggle="modal" data-bs-target="#deleteSaleTask" (click)="deleteOpenModal()">
                                    <span><i class="ri-delete-bin-5-line"></i></span>
                                </button>
                            </div>
                            <div class=" add-btn">
                                <button type="button" title="Create" (click)="createOpenModal()" data-bs-toggle="modal" data-bs-target="#createTask" class="btn btn-icon">
                                    <i class="ri-add-line"></i>
                                </button>
                            </div>
                            <div style="margin-left: 5px;">
                                <button class="btn btn-small btn-grey dropdown-toggle" type="button" id="excel-columns" data-toggle="dropdown">List View</button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" (click)="openProjectGantt()">Gantt View</a>
                                    <!-- <a class="dropdown-item" (click)="openProjectKanban()">Kanban View</a> -->
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6 d-flex" *ngIf="!this.parentProjectId">
                            <h3><a (click)="openProjectTab('myparameters')">Details</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('sub-project-list')">Sub-Project </a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('issues')"> Issues</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('task')" class="active"> Tasks</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('resources')"> Resources</a></h3>
                            <!-- <h3><a (click)="this.currentProjectId && openProjectTab('deliverables')"> Deliverables</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('decision-records')"> Decision Records</a></h3> -->
                        </div>
                        <div class="title col-sm-6 d-flex" *ngIf="this.parentProjectId">
                            <h3><a (click)="this.currentProjectId && openProjectTab('sub-project')">Sub-Project</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('issues')">Issues</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('task')" class="active">Tasks</a></h3>
                            <h3><a (click)="this.currentProjectId && openProjectTab('resources')">Resources</a></h3>
                        </div>
                    </div>
                    <ag-grid-angular
                        style="height: 620px;" 
                        class="ag-theme-material"
                        (gridReady)="onGridReady($event)" 
                        [rowData]="rowData" 
                        [columnDefs]="columnDefs"
                        pagination="true" 
                        [defaultColDef]="defaultColDef"
                        [suppressRowClickSelection]="true"
                        [rowSelection]="rowSelection"
                        (selectionChanged)="onSelectionChanged($event)"
                        paginationPageSize=10>
                    </ag-grid-angular>
                </div>
            </section>
        </section>
    </article>
</main>

<!-- Delete an item -->
<div class="modal fade" id="deleteSaleTask" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form action="">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure want to delete?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="text-center">
                        <p>{{deleteConfirmationMsg}}?</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModalDeleteProjectTask" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="selectedCheckboxData.length > 0" (click)="deleteProjectTaskList()">Yes Delete</button>
                </div>
            </form>
        </div>
    </div>
</div> 

<!-- Create new createTask -->
<div class="modal fade bd-example-modal-lg" id="createTask" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="projectTaskGridForm">
                <div class="modal-header">
                    <h5 class="modal-title">Task</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="text" formControlName="projectName" disabled required>
                                    <!-- <datalist id="projectList">
                                        <option [value]="item" *ngFor="let item of projectDropdownList"></option>
                                    </datalist> -->
                                    <label class="floating-label-special">Project Name</label>
                                    <i class="ri-file-list-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="text" formControlName="name" required>
                                    <label class="floating-label-special">Task Name*</label>
                                    <i class="ri-task-line"></i>
                                </div>
                                <mat-error *ngIf="f.name.invalid && f.name.touched" class="alert alert-danger">
                                    <mat-error *ngIf="f.name.errors.required">Name is required</mat-error>
                                </mat-error>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input" *ngIf="this.modeAction === 1">
                                <div class="input-item no-overflow">
                                    <ng-select 
                                        formControlName="taskOwnerName" 
                                        [items]="taskOwnerDropdown"  
                                        [notFoundText]="'No employees found'"  
                                        [multiple]="true"  
                                        placeholder="Select Employee" 
                                        style="width: 100%; z-index: 1; position: relative;">
                                    </ng-select>
                                    <!-- <select formControlName="taskOwnerName" multiple> -->
                                        <!-- <option value="" disabled>Select Task Owner</option> -->
                                        <!-- <option *ngFor="let taskOwner of taskOwnerDropdown" value="{{taskOwner}}">{{taskOwner}}</option>
                                    </select> -->
                                    <label class="floating-label-special">Task Owner*</label>
                                    <i class="ri-user-3-line"></i>
                                </div>
                            </div>
                            <div class="input" *ngIf="this.modeAction === 2">
                                <div class="input-item">
                                    <input type="text" formControlName="taskOwnerName" disabled required>
                                    <label class="floating-label-special">Task Owner*</label>
                                    <i class="ri-user-3-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <select formControlName="system" (change)="getSubSystemInformation($event)">
                                        <option value="" disabled>Select Business Group</option>
                                        <option *ngFor="let system of systemArray" value="{{system}}">{{system}}</option>
                                     </select>
                                    <label class="floating-label-special">Business Group Information</label>
                                    <i class="ri-menu-unfold-line"></i>
                                </div>
                            </div>
                        </div> 
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <select formControlName="subSystem" (change)="getSubSubSystemInformation($event)">
                                        <option value="" disabled>Select Commodity</option>
                                        <option *ngFor="let subSystem of subSystemArray" value="{{subSystem}}">{{subSystem}}</option>
                                     </select>
                                    <label class="floating-label-special">Commodity Information</label>
                                    <i class="ri-menu-unfold-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <select formControlName="subSubSystem">
                                        <option value="" disabled>Select Part List</option>
                                        <option *ngFor="let subSubSystem of subSubSystemArray" value="{{subSubSystem}}">{{subSubSystem}}</option>
                                     </select>
                                    <label class="floating-label-special">Part List Information</label>
                                    <i class="ri-menu-unfold-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="date" formControlName="startDate">
                                    <label class="floating-label-special">Start Date</label>
                                    <i class="ri-calendar-todo-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="date" formControlName="endDate">
                                    <label class="floating-label-special">End Date</label>
                                    <i class="ri-calendar-event-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="date" formControlName="plannedStartDate">
                                    <label class="floating-label-special">Planned Start Date</label>
                                    <i class="ri-calendar-todo-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="date" formControlName="plannedEndDate">
                                    <label class="floating-label-special">Planned End Date</label>
                                    <i class="ri-calendar-event-line"></i>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="text" formControlName="estimatedTimeInHours">
                                    <label class="floating-label-special">Estimate Time in Hours(ex. 10.5)</label>
                                    <i class="ri-timer-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <input type="text" formControlName="percentWorkCompleted">
                                    <label class="floating-label-special">Percent Work Completed(ex. 25 will be considered as 25%)</label>
                                    <i class="ri-timer-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <select formControlName="predecessorProjectTaskId">
                                        <option value="" disabled>Select Predecessor Task</option>
                                        <option *ngFor="let task of taskDropdownList" value="{{task}}">{{task}}</option>
                                     </select>
                                    <label class="floating-label-special">Predecessor task</label>
                                    <i class="ri-file-list-2-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <select formControlName="successorProjectTaskId">
                                        <option value="" disabled>Select Successor Task</option>
                                        <option *ngFor="let task of taskDropdownList" value="{{task}}">{{task}}</option>
                                     </select>
                                    <label class="floating-label-special">Successor task</label>
                                    <i class="ri-file-list-2-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                    <select formControlName="parentName">
                                        <option value="" disabled>Select Parent Task</option>
                                        <option *ngFor="let task of taskDropdownList" value="{{task}}">{{task}}</option>
                                     </select>
                                    <label class="floating-label-special">Parent task</label>
                                    <i class="ri-file-list-2-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                  <label class="floating-label floating-label-special">Status</label>
                                  <select formControlName="status" placeholder="status">
                                    <option value="" disabled selected>Select Status</option>
                                    <option value="open">Open</option>
                                    <option value="close">Close</option>
                                  </select>
                                  <i class="ri-phone-line"></i>
                                </div>
                              </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="input">
                                <div class="input-item">
                                  <label class="floating-label floating-label-special">Planned Status</label>
                                  <select formControlName="status" placeholder="plannedStatus">
                                    <option value="" disabled selected>Select Status</option>
                                    <option value="open">Open</option>
                                    <option value="close">Close</option>
                                  </select>
                                  <i class="ri-phone-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-8" *ngIf="this.modeAction === 2">
                            <div class="input">
                                <div class="input-item">
                                    <input type="file" (change)="onFileChanged($event)" placeholder="Attachment" />
                                    <label class="floating-label-special">Attachment</label>
                                    <i class="ri-attachment-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-8" *ngIf="this.modeAction === 1">
                            <div class="input">
                                <div class="input-item">
                                    <input type="file" (change)="onFileChangedBeforeTaskCreation($event)" placeholder="Attachment" />
                                    <label class="floating-label-special">Attachment</label>
                                    <i class="ri-attachment-line"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="this.modeAction === 2">
                            <div *ngFor="let item of projectTaskAttachments">
                                <table style="border: 1px dotted blue; border-radius: 10px">
                                    <tbody>
                                        <tr>
                                            <td>
                                            <span>{{ item }}</span>
                                            </td>
                                            <td>
                                            <div class="delete">
                                                <button type="button" (click)="downloadProjectTaskAttachments(item)">
                                                <span><i class="ri-download-cloud-fill"></i></span>
                                                </button>
                                            </div>
                                            </td>
                                            <td>
                                            <div class="delete">
                                                <button type="button" (click)="deleteProjectTaskAttachments(item)">
                                                <span><i class="ri-delete-bin-5-line"></i></span>
                                                </button>
                                            </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div *ngIf="this.modeAction === 1">
                            <div *ngFor="let item of projectTaskAttachments">
                                <table style="border: 1px dotted blue; border-radius: 10px">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span>{{ item }}</span>
                                            </td>
                                            <td>
                                                <div class="delete">
                                                    <button type="button" (click)="deleteProjectTaskAttachmentsBeforeTaskCreation(item)">
                                                        <span><i class="ri-delete-bin-5-line"></i></span>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        
                        <div class="col-sm-12">
                            <div class="input">
                                <div class="input-item">
                                    <textarea name="" id="" cols="12" rows="3" formControlName="description"></textarea>
                                    <label class="floating-label-special">Description</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeCreateModal" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createProjectTask()"  >Create</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" (click)="updateProjectTask()"  >Update</button> 
                </div>
            </form>
        </div>
    </div>
</div>